;(function () {
    window.Ateed.Components.ImageList = function() {
        var optionsMd = {
            arrows: false,
            centerMode: true,
            dots: true,
            slidesToShow: 3
        }
        var optionsSm = {
            arrows: false,
            centerMode: true,
            dots: true,
            slidesToShow: 1
        }
        function initD3 (options) {
            if (!$('.region-content .third-width-wrapper').hasClass('slick-initialized')) {
                $('.region-content .third-width-wrapper').slick(options)
            }
        }
        function unD3 () {
            if ($('.region-content .third-width-wrapper').hasClass('slick-initialized')) {
                $('.region-content .third-width-wrapper').slick('unslick')
            }
        }
        function initD4 (options) {
            if (!$('.region-content .quarter-width-wrapper').hasClass('slick-initialized')) {
                $('.region-content .quarter-width-wrapper').slick(options)
            }
        }
        function unD4 () {
            if ($('.region-content .quarter-width-wrapper').hasClass('slick-initialized')) {
                $('.region-content .quarter-width-wrapper').slick('unslick')
            }
        }
        function handleLg () {
            unD3()
            unD4()
        }
        function handleMd () {
            unD3()
            unD4()
            $('.region-content .third-width-wrapper').prepend(function () {
                return $(this).next().find('.third-width')
            })
            initD4(optionsMd)
        }
        function handleSm () {
            if (!$('body').hasClass('page-node-type-home-page')) {
                if ($('.region-content .quarter-width-wrapper').length > 0) {
                    unD4()
                    $('.region-content .quarter-width-wrapper').prepend(function () {
                        return $(this).prev().find('.third-width')
                    })
                    initD4(optionsSm)
                    // For image card set with only third-width children
                    // that couldn't get merged with d4 elements.
                    if ($('.region-content .third-width-wrapper .third-width').length > 2) {
                        initD3(optionsSm)
                    }
                }
                else if (
                    $('.region-content .quarter-width-wrapper').length === 0 &&
                    $('.region-content .third-width-wrapper .third-width').length > 2
                ) {
                    initD3(optionsSm)
                }
            }
        }

        function handleRender () {
            if ($(window).width() > 768) { handleLg() }
            else if ($(window).width() > 640 && $(window).width() <= 768) { handleMd() }
            else if ($(window).width() <= 640) { handleSm() }
        }
        if (!$('body').hasClass('page-node-type-microsite-home-page-index')) {
          handleRender()
          $(window).resize(handleRender)
        }
    }
})();
